// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"925b88fc","191":"15a64306","200":"1523e1ad","316":"99e49b31","328":"f7b2cef7","356":"ce84a996","427":"52569beb","488":"edda780f","638":"980cc3fc","759":"00a54bde","823":"fddeda52","853":"5907fcbb","900":"f18961a3","942":"b502e1b4","977":"978fd0e2"}[chunkId] + ".chunk.js";
};